export default __webpack_public_path__ + "static/media/bazzodecorLogo.6abdfffb.jpg";